import { z } from 'zod';

export const userProfileEnum = z.enum(['ADMIN', 'FINANCEIRO', 'CAIXA', 'COORDENADOR_CAMPANHA', 'COORDENADOR_EVENTO', 'VISUALIZADOR']);

export const loginInput = z.object({
  email: z.string().email('Email invalido'),
  senha: z.string().min(6, 'Senha deve ter no minimo 6 caracteres'),
});

export const loginOutput = z.object({
  token: z.string(),
  expiresAt: z.date(),
  user: z.object({
    id: z.string(),
    nome: z.string(),
    email: z.string(),
    permissoes: z.array(userProfileEnum),
  }),
});

export const changePasswordInput = z.object({
  senhaAtual: z.string().min(1, 'Senha atual e obrigatoria'),
  novaSenha: z.string().min(6, 'Nova senha deve ter no minimo 6 caracteres'),
});

export const meOutput = z.object({
  id: z.string(),
  nome: z.string(),
  email: z.string(),
  permissoes: z.array(userProfileEnum),
  ativo: z.boolean(),
  createdAt: z.date(),
});

export const registerInput = z.object({
  nome: z.string().min(2, 'Nome deve ter no minimo 2 caracteres'),
  email: z.string().email('Email invalido'),
  senha: z.string().min(6, 'Senha deve ter no minimo 6 caracteres'),
});

export const forgotPasswordInput = z.object({
  email: z.string().email('Email invalido'),
});

export const resetPasswordInput = z.object({
  token: z.string().min(1, 'Token é obrigatório'),
  novaSenha: z.string().min(6, 'Nova senha deve ter no mínimo 6 caracteres'),
});

export type LoginInput = z.infer<typeof loginInput>;
export type LoginOutput = z.infer<typeof loginOutput>;
export type ChangePasswordInput = z.infer<typeof changePasswordInput>;
export type MeOutput = z.infer<typeof meOutput>;
export type RegisterInput = z.infer<typeof registerInput>;
export type ForgotPasswordInput = z.infer<typeof forgotPasswordInput>;
export type ResetPasswordInput = z.infer<typeof resetPasswordInput>;
